var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-navbar",
    { staticClass: "header d-print-none" },
    [
      _c(
        "b-nav",
        [
          _c(
            "b-nav-item",
            [
              _c(
                "a",
                {
                  staticClass: "d-md-down-none px-2",
                  attrs: { href: "#", id: "barsTooltip" },
                  on: { click: _vm.toggleSidebarMethod }
                },
                [_c("i", { staticClass: "la la-bars la-lg" })]
              ),
              _vm._v(" "),
              _c(
                "b-tooltip",
                { attrs: { target: "barsTooltip", placement: "bottom" } },
                [
                  _vm._v("\n          Turn on/off "),
                  _c("br"),
                  _vm._v(" sidebar "),
                  _c("br"),
                  _vm._v(" collapsing\n        ")
                ]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "fs-lg d-lg-none",
                  attrs: { href: "#" },
                  on: { click: _vm.switchSidebarMethod }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "rounded rounded-lg bg-gray text-white d-md-none"
                    },
                    [_c("i", { staticClass: "la la-bars la-lg" })]
                  ),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "la la-bars la-lg d-sm-down-none ml-4"
                  })
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("a", { staticClass: "navbarBrand d-md-none" }, [
        _c("i", { staticClass: "fa fa-circle text-gray mr-n-sm" }),
        _vm._v(" "),
        _c("i", { staticClass: "fa fa-circle text-warning" }),
        _vm._v("\n       \n      Starchase\n       \n      "),
        _c("i", { staticClass: "fa fa-circle text-warning mr-n-sm" }),
        _vm._v(" "),
        _c("i", { staticClass: "fa fa-circle text-gray" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "ml-auto" }, [
        _vm._v(_vm._s(_vm.getDisplayName()))
      ]),
      _vm._v(" "),
      _c(
        "b-nav",
        [
          _c(
            "b-nav-item-dropdown",
            {
              staticClass: "settingsDropdown d-sm-down-none",
              attrs: { "no-caret": "", right: "" }
            },
            [
              _c("template", { slot: "button-content" }, [
                _c("i", { staticClass: "la la-cog px-2" })
              ]),
              _vm._v(" "),
              _c("b-dropdown-item-button", { on: { click: _vm.logoutUser } }, [
                _c("i", { staticClass: "la la-sign-out" }),
                _vm._v(" Log Out\n        ")
              ])
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }